import { Asset } from '@/types/assets';
import { Employee, EmployeeWithAssets } from '@/types/employees';

// Casts Employee[] to EmployeeWithAssets[] for use with useTableSelection.
// The selection hook only reads .id — assets are not needed and not available across pages.
export const castEmployeesForSelection = (
  employees: Employee[]
): EmployeeWithAssets[] => employees.map(e => ({ ...e, assets: [] }));

const convertEmployeesToEmployeeWithAssets = <GenericAsset extends Asset>({
  employees,
  assets,
}: {
  employees: Employee[];
  assets: GenericAsset[];
}): EmployeeWithAssets[] => {
  const assetsEmployeeMap: Record<string, Asset[]> = assets.reduce(
    (acc: Record<string, Asset[]>, asset: Asset) => {
      if (!asset.assignedTo) {
        return acc;
      }
      const employeesAssets = acc[asset.assignedTo] || [];

      return {
        ...acc,
        [asset.assignedTo]: [...employeesAssets, asset],
      };
    },
    {}
  );

  return employees.map(employee => {
    const assets = assetsEmployeeMap[employee.id];
    return {
      ...employee,
      assets,
    };
  });
};

export default convertEmployeesToEmployeeWithAssets;
